<template>
  <div class="internal-transfer-simulator">
    <div class="simulator-row">
      <label class="simulator-label">Envías</label>
      <div class="simulator-input-group">
        <input
          type="tel"
          inputmode="numeric"
          v-model="sourceAmount"
          @input="calculate"
          class="simulator-input"
          placeholder="0"
        />
        <span class="simulator-currency">{{ sourceCurrency }}</span>
      </div>
    </div>

    <div class="simulator-row" v-if="rates && Object.keys(rates).length > 1">
      <label class="simulator-label">Moneda destino</label>
      <select v-model="selectedDestCurrency" @change="calculate" class="simulator-select">
        <option v-for="currency in Object.keys(rates)" :key="currency" :value="currency">
          {{ currency }}
        </option>
      </select>
    </div>

    <div class="simulator-divider">
      <span class="material-icons-sharp">arrow_downward</span>
    </div>

    <div class="simulator-row">
      <label class="simulator-label">Recibe</label>
      <div class="simulator-result">
        <span class="simulator-result-amount">{{ formattedDestAmount }}</span>
        <span class="simulator-currency">{{ selectedDestCurrency }}</span>
      </div>
    </div>

    <div class="simulator-details" v-if="currentRate">
      <div class="simulator-detail">
        <span>Tasa:</span>
        <span>1 {{ sourceCurrency }} = {{ currentRate.rate }} {{ selectedDestCurrency }}</span>
      </div>
      <div class="simulator-detail">
        <span>Comisión:</span>
        <span>{{ (currentRate.fee * 100).toFixed(1) }}%</span>
      </div>
    </div>
  </div>
</template>

<style scoped>
.internal-transfer-simulator {
  padding: 16px;
  border-radius: 16px;
  background: var(--stepper-background, rgba(228, 228, 228, 0.60));
}

.simulator-row {
  margin-bottom: 12px;
}

.simulator-label {
  font-size: 12px;
  color: #6c757d;
  margin-bottom: 4px;
  display: block;
}

.simulator-input-group {
  display: flex;
  align-items: center;
  gap: 8px;
}

.simulator-input {
  flex: 1;
  font-size: 24px;
  font-weight: 600;
  border: none;
  background: transparent;
  outline: none;
  color: var(--text-color);
}

.simulator-currency {
  font-size: 14px;
  font-weight: 500;
  color: #6c757d;
}

.simulator-select {
  width: 100%;
  padding: 8px;
  border-radius: 8px;
  border: 1px solid #e0e0e0;
  background: transparent;
}

.simulator-divider {
  text-align: center;
  color: #6c757d;
  margin: 8px 0;
}

.simulator-result {
  display: flex;
  align-items: center;
  gap: 8px;
}

.simulator-result-amount {
  font-size: 24px;
  font-weight: 600;
  color: #28a745;
}

.simulator-details {
  margin-top: 16px;
  padding-top: 12px;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
}

.simulator-detail {
  display: flex;
  justify-content: space-between;
  font-size: 12px;
  color: #6c757d;
  margin-bottom: 4px;
}
</style>

<script>
export default {
  name: "InternalTransferSimulator",
  props: {
    sourceCurrency: {
      type: String,
      required: true,
    },
    rates: {
      type: Object,
      required: true,
    },
    initialDestCurrency: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      sourceAmount: '',
      selectedDestCurrency: this.initialDestCurrency || Object.keys(this.rates)[0] || '',
      destAmount: 0,
    };
  },
  computed: {
    currentRate() {
      if (!this.rates || !this.selectedDestCurrency) return null;
      const rateGroup = this.rates[this.selectedDestCurrency];
      return rateGroup ? rateGroup[0] : null;
    },
    formattedDestAmount() {
      if (!this.destAmount) return '0';
      return new Intl.NumberFormat('es-CL', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
      }).format(this.destAmount);
    },
  },
  methods: {
    calculate() {
      if (!this.sourceAmount || !this.currentRate) {
        this.destAmount = 0;
        return;
      }
      const amount = parseFloat(this.sourceAmount.toString().replace(/[^0-9.]/g, ''));
      if (isNaN(amount)) {
        this.destAmount = 0;
        return;
      }
      const rate = parseFloat(this.currentRate.rate);
      const fee = parseFloat(this.currentRate.fee);
      this.destAmount = amount * rate * (1 - fee);
      this.$emit('calculated', {
        sourceAmount: amount,
        destAmount: this.destAmount,
        destCurrency: this.selectedDestCurrency,
        rate: this.currentRate,
      });
    },
  },
};
</script>
